import React, { useEffect, useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    TextField,
    Typography,
} from '@material-ui/core';
import { css } from '@emotion/react';
import { PrimaryButton, SecondaryButton } from '@/styles/blocks';

export default function LoadTemplateModal({ open, templates, loadedTemplate, loading, onCancel, onLoad }) {
    const [selectedTemplateId, setSelectedTemplateId] = useState(null);

    useEffect(() => {
        if (!open) return;
        setSelectedTemplateId(loadedTemplate?.cycle_count_template_id || null);
    }, [loadedTemplate, open]);

    const selectedTemplate = (templates || []).find(
        (template) => template.cycle_count_template_id === selectedTemplateId
    );
    const loadDisabled = loading || !selectedTemplate;
    const hasTemplates = (templates || []).length > 0;

    return (
        <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
            <DialogTitle>Load Template</DialogTitle>
            <DialogContent>
                {hasTemplates || loading ? (
                    <TextField
                        select
                        fullWidth
                        variant="outlined"
                        label={loading ? 'Loading templates...' : 'Template'}
                        value={selectedTemplateId || ''}
                        onChange={(e) => setSelectedTemplateId(e.target.value || null)}
                        disabled={loading}
                    >
                        <MenuItem value="">
                            <em>Select template</em>
                        </MenuItem>
                        {(templates || []).map((template) => (
                            <MenuItem
                                key={template.cycle_count_template_id}
                                value={template.cycle_count_template_id}
                            >
                                {template.name}
                            </MenuItem>
                        ))}
                    </TextField>
                ) : (
                    <Typography
                        css={css`
                            text-align: center;
                            padding: 1rem 0;
                        `}
                    >
                        No templates found for this warehouse.
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <SecondaryButton onClick={onCancel}>Cancel</SecondaryButton>
                <PrimaryButton onClick={() => onLoad(selectedTemplate)} disabled={loadDisabled}>
                    Load
                </PrimaryButton>
            </DialogActions>
        </Dialog>
    );
}
